import { Link } from "react-router-dom";
import { genres } from "@/mocks/genres";

export default function GenreGrid() {
  return (
    <section className="bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto max-w-page px-4 md:px-6">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="mb-2 flex items-center gap-2 font-label text-[12px] uppercase tracking-[0.24em] text-primary-600">
              <span className="inline-block h-[1px] w-6 bg-accent-500"></span>
              按类型浏览
            </p>
            <h2 className="font-heading text-2xl font-semibold text-foreground-950 md:text-3xl">
              八十年代的光影分区
            </h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-foreground-600">
            动作片的引擎、科幻片的霓虹、爱情片的对白——选择一种类型，进入那个年代的某一面。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-4 lg:grid-cols-6">
          {genres.slice(0, 6).map((genre) => (
            <Link
              key={genre.name}
              to={`/category?genre=${encodeURIComponent(genre.name)}`}
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 hover:bg-background-50"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-600 group-hover:text-background-50">
                <i className={`${genre.icon} text-lg`}></i>
              </span>
              <span className="mt-3 font-heading text-lg font-semibold text-foreground-950">
                {genre.name}
              </span>
              <span className="mt-1 text-xs leading-relaxed text-secondary-600">{genre.description}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}